export default "__VITE_ASSET__AlPlGHRk__"